'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEcadPro = exports.ApiClientRefreshToken = exports.UserApi = exports.MovementApi = exports.LongpollingApi = exports.ExportAPIApi = exports.AuthdbApi = exports.User = exports.UploadResponse = exports.UploadJSON = exports.StartRenderResponse = exports.ShareRequest = exports.RenderInfo = exports.NewRenderResponse = exports.MovementList = exports.Movement = exports.Login = exports.ExportRenderData = exports.ErrorResponse = exports.DataTable = exports.AuthorizationServerError = exports.AuthorizationServer = exports.Authorization = exports.ApiClient = undefined;
exports.getEcadProViews = getEcadProViews;
exports.setEcadProAuth = setEcadProAuth;
exports.getEcadProAuth = getEcadProAuth;
exports.getEcadProLang = getEcadProLang;
exports.getEcadProSceeneQuality = getEcadProSceeneQuality;
exports.getEcadProToken = getEcadProToken;
exports.getEcadProOrderDetails = getEcadProOrderDetails;
exports.sendEcadProRender = sendEcadProRender;
exports.saveEcadProBase64 = saveEcadProBase64;
exports.deleteEcadProView = deleteEcadProView;
exports.isRedwayMode = isRedwayMode;
exports.setBackendForRedway = setBackendForRedway;

var _ApiClient = require('./ApiClient');

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _Authorization = require('./model/Authorization');

var _Authorization2 = _interopRequireDefault(_Authorization);

var _AuthorizationServer = require('./model/AuthorizationServer');

var _AuthorizationServer2 = _interopRequireDefault(_AuthorizationServer);

var _AuthorizationServerError = require('./model/AuthorizationServerError');

var _AuthorizationServerError2 = _interopRequireDefault(_AuthorizationServerError);

var _DataTable = require('./model/DataTable');

var _DataTable2 = _interopRequireDefault(_DataTable);

var _ErrorResponse = require('./model/ErrorResponse');

var _ErrorResponse2 = _interopRequireDefault(_ErrorResponse);

var _ExportRenderData = require('./model/ExportRenderData');

var _ExportRenderData2 = _interopRequireDefault(_ExportRenderData);

var _Login = require('./model/Login');

var _Login2 = _interopRequireDefault(_Login);

var _Movement = require('./model/Movement');

var _Movement2 = _interopRequireDefault(_Movement);

var _MovementList = require('./model/MovementList');

var _MovementList2 = _interopRequireDefault(_MovementList);

var _NewRenderResponse = require('./model/NewRenderResponse');

var _NewRenderResponse2 = _interopRequireDefault(_NewRenderResponse);

var _RenderInfo = require('./model/RenderInfo');

var _RenderInfo2 = _interopRequireDefault(_RenderInfo);

var _ShareRequest = require('./model/ShareRequest');

var _ShareRequest2 = _interopRequireDefault(_ShareRequest);

var _StartRenderResponse = require('./model/StartRenderResponse');

var _StartRenderResponse2 = _interopRequireDefault(_StartRenderResponse);

var _UploadJSON = require('./model/UploadJSON');

var _UploadJSON2 = _interopRequireDefault(_UploadJSON);

var _UploadResponse = require('./model/UploadResponse');

var _UploadResponse2 = _interopRequireDefault(_UploadResponse);

var _User = require('./model/User');

var _User2 = _interopRequireDefault(_User);

var _AuthdbApi = require('./api/AuthdbApi');

var _AuthdbApi2 = _interopRequireDefault(_AuthdbApi);

var _ExportAPIApi = require('./api/ExportAPIApi');

var _ExportAPIApi2 = _interopRequireDefault(_ExportAPIApi);

var _LongpollingApi = require('./api/LongpollingApi');

var _LongpollingApi2 = _interopRequireDefault(_LongpollingApi);

var _MovementApi = require('./api/MovementApi');

var _MovementApi2 = _interopRequireDefault(_MovementApi);

var _UserApi = require('./api/UserApi');

var _UserApi2 = _interopRequireDefault(_UserApi);

var _ApiClientRefreshToken = require('./ApiClientRefreshToken');

var _ApiClientRefreshToken2 = _interopRequireDefault(_ApiClientRefreshToken);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ApiClient = _ApiClient2.default;
exports.Authorization = _Authorization2.default;
exports.AuthorizationServer = _AuthorizationServer2.default;
exports.AuthorizationServerError = _AuthorizationServerError2.default;
exports.DataTable = _DataTable2.default;
exports.ErrorResponse = _ErrorResponse2.default;
exports.ExportRenderData = _ExportRenderData2.default;
exports.Login = _Login2.default;
exports.Movement = _Movement2.default;
exports.MovementList = _MovementList2.default;
exports.NewRenderResponse = _NewRenderResponse2.default;
exports.RenderInfo = _RenderInfo2.default;
exports.ShareRequest = _ShareRequest2.default;
exports.StartRenderResponse = _StartRenderResponse2.default;
exports.UploadJSON = _UploadJSON2.default;
exports.UploadResponse = _UploadResponse2.default;
exports.User = _User2.default;
exports.AuthdbApi = _AuthdbApi2.default;
exports.ExportAPIApi = _ExportAPIApi2.default;
exports.LongpollingApi = _LongpollingApi2.default;
exports.MovementApi = _MovementApi2.default;
exports.UserApi = _UserApi2.default;
exports.ApiClientRefreshToken = _ApiClientRefreshToken2.default;

// Ecad Pro detection
/**
 * RF Server API
 * this is the API for the RF server
 *
 * OpenAPI spec version: 1.0.0
 * Contact: bryan@dau.it
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

var isEcadPro = exports.isEcadPro = window.external && typeof window.external.Comunica !== 'undefined';

function getEcadProViews() {
    if (!isEcadPro) throw 'This isn\'t Ecadpro browser';

    var views = null;
    try {
        views = JSON.parse(window.external.Comunica('GetViews'));
    } catch (err) {
        alert('Failed parsing views data');
    }

    return views;
}

function setEcadProAuth(Auth) {
    if (!isEcadPro) throw 'This isn\'t Ecadpro browser';

    return window.external.Comunica('SetAuth:' + JSON.stringify(Auth));
}

function getEcadProAuth() {
    if (!isEcadPro) throw 'This isn\'t Ecadpro browser';

    var auth = null;
    try {
        auth = JSON.parse(window.external.Comunica('GetAuth'));
    } catch (err) {
        //alert('Failed parsing auth data');
    }

    return auth;
}

function getEcadProLang() {
    if (!isEcadPro) throw 'This isn\'t Ecadpro browser';

    var ecpLang = null;
    try {
        ecpLang = window.external.Comunica('GetLang');
    } catch (err) {
        alert(err);
    }

    if (!ecpLang) ecpLang = 'IT';

    var lang = null;
    switch (ecpLang.toUpperCase ? ecpLang.toUpperCase() : ecpLang) {
        case 'D':
            lang = 'de_DE';
            break;
        case 'ES':
            lang = 'es_ES';
            break;
        case 'FR':
            lang = 'fr_FR';
            break;
        case 'GR':
            lang = 'el_GR';
            break;
        case 'IT':
            lang = 'it_IT';
            break;
        case 'NL':
            lang = 'nl_NL';
            break;
        case 'NO':
            lang = 'no_NO';
            break;
        case 'PL':
            lang = 'pl_PL';
            break;
        case 'PT':
            lang = 'pt_PT';
            break;
        case 'RU':
            lang = 'ru_RU';
            break;
        case 'ZH':
            lang = 'zh_CN';
            break;
        case 'SE':
            lang = 'sv_SE';
            break;
        case 'TH':
            lang = 'th_TH';
            break;
        case 'HR':
            lang = 'hr_HR';
            break;
        case 'EN':
        default:
            lang = 'en_GB';
            break;
    }
    return lang;
}

function getEcadProSceeneQuality() {
    if (!isEcadPro) throw 'This isn\'t Ecadpro browser';

    var quality = [];
    try {
        quality = JSON.parse(window.external.Comunica('GetSceneQuality'));
    } catch (err) {
        alert('Failed parsing quality data');
    }

    return quality;
}

function getEcadProToken() {
    if (!isEcadPro) throw 'This isn\'t Ecadpro browser';

    var ecadToken = null;
    try {
        ecadToken = JSON.parse(window.external.Comunica('GetSoftwareToken'));
    } catch (err) {
        alert('Failed parsing software token data');
    }
    return ecadToken;
}

function getEcadProOrderDetails() {
    if (!isEcadPro) throw 'This isn\'t Ecadpro browser';

    var details = null;
    try {
        details = JSON.parse(window.external.Comunica('GetOrderDetails'));
    } catch (err) {
        alert('Failed parsing software token data');
    }
    return details;
}

function sendEcadProRender(authToken, guid, remoteServer, rendersList) {

    if (!isEcadPro) throw 'This isn\'t Ecadpro browser';

    var csvData = '';
    csvData += authToken + '\n';
    csvData += guid + '\n';
    csvData += remoteServer + '\n';

    for (var i = 0; i < rendersList.length; i++) {
        if (!rendersList[i].quality || !rendersList[i].quality.name) {
            alert('Quality is not set');
            return;
        }
        csvData += '' + rendersList[i].quality.name + ';' + (rendersList[i].selected ? '1' : '0') + '\n';
    }

    return window.external.Comunica('SendRender:' + csvData);
}

function saveEcadProBase64(base64str) {

    if (!isEcadPro) throw 'This isn\'t Ecadpro browser';

    window.external.Comunica('SaveBase64:' + base64str);
}

/** Delete view nand get new list of views
 *
 * @param viewId
 * @returns {*}
 */
function deleteEcadProView(viewId) {
    if (!isEcadPro) throw 'This isn\'t Ecadpro browser';
    var views = null;
    try {
        views = JSON.parse(window.external.Comunica('RemoveView:' + viewId));
    } catch (err) {
        alert('Failed parsing views data');
    }
    return views;
}

function isRedwayMode() {
    if (!isEcadPro) return false;
    try {
        var result = window.external.Comunica('ISREDWAYMODE:');
        if (result == "1") return true;
    } catch (err) {
        alert('Failed isRedwayMode');
    }
    return false;
}

function setBackendForRedway(server_url) {
    if (!isEcadPro) throw 'This isn\'t Ecadpro browser';
    try {
        var result = window.external.Comunica('SETBACKEND:' + server_url);
    } catch (err) {
        alert('Failed setBackendForRedway');
    }
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/renderfarmapi/lib/lib-commonjs/index.js
// module id = 269
// module chunks = 142